import axios from "axios";
import filterZeroAccounts from './filterZeroAccounts';

let ACCOUNTS_URL;
if(sessionStorage.getItem('app_info')){
	ACCOUNTS_URL = JSON.parse(sessionStorage.getItem('app_info')).ACCOUNTS_URL;
} 

const numberWithCommas = (x) => {
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

export const emailReceipt = (emailReceiptPayload) =>{
    const {payerEmail,accType,paymentDate,totalAmount,confirmationNumber,
      accountNumber,customerID,selectedPayMethod,accounts}=emailReceiptPayload
    let filteredAccounts = filterZeroAccounts(accounts);
    const totalAmountDollar = numberWithCommas(totalAmount.split(".")[0]);
    const totalAmountCents = totalAmount.split(".")[1];
    const formattedTotalAmount = totalAmountDollar + "." + totalAmountCents;
    let accountArray = [];
    console.log(accounts);
    for (var key in filteredAccounts) {
        if(filteredAccounts.hasOwnProperty(key)){
          let account = {};
          let act = filteredAccounts[key];
          account.billingAccountNumber = key;
          account.amount = act.toString();
          account.accountType=false;
          if(accounts[key].product_code==="RSCIA")
            account.accountType=true;
          accountArray.push(account);

        }
    }

    let acct_num;
    let paymentType;
    if(accType === "bank"){
        
        acct_num = accountNumber.substring(accountNumber.length - 4);
        paymentType = "ACH";
    }else{
        acct_num = accountNumber.substring(accountNumber.length - 4);
        paymentType = "CreditCard";
    }

    let postData = {
        "payerEmail": payerEmail,
        "paymentType": paymentType,
        
        "paymentDate": paymentDate,
        "paymentAmount": formattedTotalAmount,
        
        "confirmationNumber": confirmationNumber,
        "bankAccountNumber": acct_num,
        "billingAccountNumber": customerID,
        "paymentDetails": accountArray,
        "selectedPaymentMethod": selectedPayMethod
    };

    axios({
      method: 'post',
      url: `${ACCOUNTS_URL}/sendPaymentReceipt`,
      data: postData
    })
    .then(() => {})
    .catch((err) => {
      console.log("EMAIL_ERROR",err);
    });
}



// WEBPACK FOOTER //
// ./src/utils/emailReceipt.js